import { CALL_API } from 'containers/App/screens/Tube/utils/oldApi';
import { url } from 'configs';
import axios from 'axios';

const {
  API_SERVER,
  NEWTUBE_API_SERVER,
} = url;

const path = 'tube/accountsetting';
const FETCH_IP_RESTRICT = `${path}FETCH_CV_FIELDS`;

const POST_CHANGEPASSWORD_REQUEST = 'tube/accountsetting/POST_CHANGEPASSWORD_REQUEST';
const POST_CHANGEPASSWORD_SUCCESS = 'tube/accountsetting/POST_CHANGEPASSWORD_SUCCESS';
const POST_CHANGEPASSWORD_ERROR = 'tube/accountsetting/POST_CHANGEPASSWORD_ERROR';

export function postChangePassword(formData) {
  return {
    [CALL_API]: {
      url: `${API_SERVER}Account/changePassword`,
      headers: {
        FunctionCode: 'ChangePassword',
        ActionCode: 'Default',
      },
      method: 'POST',
      types: [POST_CHANGEPASSWORD_REQUEST, POST_CHANGEPASSWORD_SUCCESS, POST_CHANGEPASSWORD_ERROR],
      params: formData,
    },
  };
}

export function fetchIPRestrict() {
  return {
    type: FETCH_IP_RESTRICT,
    payload: axios.get(`${NEWTUBE_API_SERVER}iprestrict`, {
      headers: {
        FunctionCode: 'ChangePassword',
        ActionCode: 'Default',
      },
    }),
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/AccountSetting/reducers/index.js
 **/